import { color, font, layer } from '../tokens.js';

/**
 * "KALNDAR" above the sign-in, sign-up and first-colour screens (owner, 4 October 2026). Centred on
 * the stage, inside the band a phone shows, above the title row at (440, 150). The page title
 * already names the site, so screen readers skip it.
 */
export function Wordmark() {
  return <div aria-hidden="true" data-v1-wordmark="" style={{ position: 'absolute', left: 440, top: 72, width: 560, height: 36, zIndex: layer.header, display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }}>
    {/* The trailing letter spacing is given back on the left, so the word sits on the centre line. */}
    <span style={{ paddingLeft: '0.32em', fontFamily: font.label, fontSize: 24, fontWeight: 600, letterSpacing: '0.32em', lineHeight: '36px', color: color.textStrong }}>KALNDAR</span>
  </div>;
}
